export default {
  agreeTitle:
    'Acuerdo de Servicios de Marketing a través del "afiliado de acbuy" en el sitio web de acbuy',
  agreementText: `Bienvenido a registrarse en el sitio web de acbuy y utilizar sus servicios de marketing de "afiliado de acbuy". Este Acuerdo se celebra entre los socios de "afiliado de acbuy" (en adelante, "Partido B") y acbuy (en adelante, "Partido A") (incluyendo, pero no limitado a www.acbuy.com, la aplicación móvil de acbuy, etc., en adelante, "Sitio web de Partido A") en relación con los asuntos relacionados con los servicios de marketing de "afiliado de acbuy". El Partido B debe leer detenidamente todo el texto aquí, especialmente las partes en negrita, antes de utilizar los servicios de marketing de "afiliado de acbuy" en el sitio web de acbuy, y al hacer clic en el botón "He leído y estoy de acuerdo", se considerará que el Partido B ha aceptado y está de acuerdo en cumplir con las especificaciones aquí. Este Acuerdo constituirá el acuerdo entre el Partido B y acbuy y tendrá fuerza legal. acbuy tendrá el derecho de modificar los artículos aquí unilateralmente en función de sus necesidades comerciales, y acbuy publicará dichas modificaciones en el Sitio web de Partido A inmediatamente en caso de que se realicen modificaciones en los artículos aquí, y el Partido B deberá dejar de utilizar los servicios de marketing en el canal de "afiliado de acbuy" inmediatamente en caso de que no esté de acuerdo con las modificaciones de los textos aquí, o de lo contrario, se considerará que el Partido B está de acuerdo con las modificaciones de los textos aquí.
Artículo 1 Definiciones 1. Consumidor: significa miembro de acbuy que accede al Sitio web de Partido A para registrarse `,
  dashboard: 'Tablero de control',
  hi: 'Hola, ',
  inviteFriends: 'Invita a amigos',
  inviteFriendsTips:
    'Invita a amigos a acbuy, gana más dinero en efectivo! Invita a más amigos, gana más, sin límite.',
  inviteFriendsTips1:
    'Invita a 3 cuentas activas para obtener derechos de venta y ganar comisiones.',
  totalInvite: 'Usuarios invitados totales',
  myTeam: 'Mi equipo',
  extractMoney: 'Comisión liquidada',
  noExtractMoney: 'Comisión no liquidada',
  inviteTitle: 'Invita a mis amigos',
  copyCode: 'Copiar código de invitación',
  poster: 'Cartel exclusivo',
  myLevel: 'Mi prerrogativa ',
  youLevel: 'Tu nivel actual',
  commissionRate: 'Tasa de comisión',
  experienceValue: 'Valor de experiencia({num}/{total})',
  levelDesc: 'Descripción del nivel',
  invite: 'Invitar',
  revenueDetails: 'Detalles de la invitación',
  registerTime: 'Hora de registro',
  inviteType: 'Relaciones relacionadas',
  userMail: 'Correo electrónico de usuario',
  bonus: 'Bonificación',
  myBonus: 'Mi bonificación',
  myBalance: 'Mi saldo',
  applyWithdraw: 'Solicitar retiro',
  withdrawTips:
    'Sugerencia: Debido a la comisión de transacción involucrada en el retiro, se recomienda retirar una cantidad superior a ¥500.00 ',
  bank: 'Banco',
  paypalAccount: 'Cuenta de PayPal',
  bankAccount: 'Cuenta bancaria',
  bankName: 'Nombre del banco',
  withdrawAmount: 'Monto de retiro({unit})',
  bonusDetail: 'Detalles de la bonificación',
  directCommission: 'Detalles de la comisión directa',
  indirectCommission: 'Detalles de la comisión indirecta',
  tradeTime: 'Hora de la transacción',
  packNo: 'Número de paquete',
  actCommission: 'Comisión',
  settlementTime: 'Hora de liquidación',
  levelName: 'Nivel de embajador',
  packStatus: 'Estado del paquete',
  directExplain: 'Tasa de comisión',
  indirectExplain: `Comisión sobre los gastos de envío de los invitados secundarios`,
  experienceExplain: 'Valor de experiencia',
  withdrawRecord: 'Registro de retiros',
  withdrawTime: 'Hora de retiro',
  serialNo: 'Número de serie',
  withdrawStatus: 'Estado del retiro',
  team: 'Equipo',
  levelUp: 'Subir de nivel',
  teamInfo: 'Información del equipo',
  teamNum: 'Número de usuarios del equipo',
  monthCommission: 'Comisión estimada para este mes',
  accCommission: 'Comisión de liquidación acumulada',
  teamMember: 'Miembro del equipo',
  promotedMember: 'Miembro promovido',
  invitationTime: 'Hora de invitación',
  inviter: 'Invitador',
  promotionTime: 'Hora de promoción',
  IBAN: 'IBAN',
  swiftCode: 'Código SWIFT',
  bankAddress: 'Dirección del banco',
  setting: 'Configuración',
  profile: 'Perfil',
  withdrawMethod: 'Método de retiro',
  myPrerogative: 'Mi prerrogativa',
  verifyEmail: 'Verifica tu correo electrónico',
  sendCodeTips:
    'Hemos enviado un código de verificación a <strong>{email}</strong>. Ingresa el código a continuación para verificar.',
  noGetEmail: `¿No has recibido tu correo electrónico?`,
  codeErrorTips: 'Código incorrecto, por favor intenta de nuevo',
  resendTime: 'Reenviar el código ({time}s)',
  or: 'o',
  contactService: 'Contacta con el servicio de atención al cliente en línea',
  addMethod: 'Nuevo método de retiro',
  editMethod: 'Editar método de retiro',
  rePaypalAccount: 'Volver a ingresar la cuenta de PayPal',
  directInvite: 'Invitación directa',
  indirectInvite: 'Invitación indirecta',
  noSameAccount: 'La cuenta es diferente a la cuenta confirmada',
  noAddWithdrawMethod: `No has agregado un método de retiro`,
  statusEnum: {
    0: 'Por emitir',
    1: 'En emisión',
    2: 'Emisión exitosa',
    3: 'Fallo de aprovisionamiento',
    4: 'Retiro de retiro'
  },
  userDetail: 'Detalles del usuario',
  balance: 'Saldo de la cuenta',
  withdrawMax: 'Monto superior a ¥500.00',
  addPaypalAccount: 'Agregar cuenta de PayPal',
  addBankAccount: 'Agregar cuenta bancaria',
  noPaypalAccount: 'Sin cuenta de PayPal',
  noBankAccount: 'Sin cuenta bancaria',
  estimated: 'Firmado',
  notEstimated: 'No firmado',
  actual: 'Real',
  estiamte: 'Estimado',
  directRealtion: 'Relación directa',
  indirectRealtion: 'Relación indirecta',
  experienceValueText: 'Valor de experiencia',
  relatedParcel: 'Paquete relacionado',
  empiricalValue: 'Valor empírico',
  acquiringTime: 'Hora de adquisición',
  relatedEmail: 'Correo electrónico relacionado',
  relatedUsers: 'Usuarios relacionados',
  balanceDetail: 'Detalles del saldo',
  commissionDetail: 'Detalles de la comisión',
  details: 'Detalles',
  question1:
    'Después de que el usuario invitado complete el pedido, su estado se actualizará a "Activado"',
  question2:
    'El pedido se ha completado y la comisión se ha transferido a tu cuenta de saldo',
  question3:
    'Comisión de todos los pedidos "sin confirmación de recepción". El pedido se verificará en un plazo de 30 a 60 días, y luego la comisión se transferirá a tu cuenta de saldo',
  activatedUser: 'Usuario activado',
  bankTip: 'Comisión de gestión de retiro: 2% del monto de retiro',
  selectWithdrawMethod: 'Seleccionar cuenta de retiro',
  currentWithdrawAmount: 'Monto disponible para retiro actual',
  modify: 'Modificar',
  bonusBalance: 'Saldo disponible de bonificación',
  balanceTips1:
    '1. Pago de la bonificación de liquidación del mes anterior el día 1 de cada mes',
  balanceTips2:
    '2. Del día 1 al 10 de cada mes es la fecha de retiro, y puedes elegir retirar del día 1 al 10. Te transferiremos los fondos antes del día 20, y después de la transferencia, te notificaremos el resultado de la transferencia por correo electrónico. Al mismo tiempo, puedes consultar la información relacionada con la transferencia en el registro de retiros.',
  income: 'Ingreso',
  expenditure: 'Gasto',
  commissionSettlement: 'Liquidación de comisión',
  commissionWithdrawal: 'Retiro de comisión',
  withdrawalCancellation: 'Cancelación de retiro',
  activeStatus: 'Estado activo',
  settlePackageNum: 'Cantidad de paquetes',
  activeTime: 'Hora de activación',
  orderTime: 'Hora de envío del paquete',
  orderUser: 'Usuario del pedido',
  actualFreight: 'Pago real de flete',
  estimatedCommission: 'Comisión estimada',
  withdrawAccount: 'Cuenta de retiro',
  withdrawType: 'Tipo de retiro',
  withdrawTypeEnum: {
    2: 'Retirar al saldo',
    0: 'Retirar al banco'
  },
  applyTime: 'Fecha de solicitud',
  withdrawStatusEnum: {
    0: 'En revisión',
    1: 'Retirando',
    2: 'Retiro exitoso',
    3: 'Retiro rechazado',
    4: 'Retiro cancelado'
  },
  bankEndNumber: 'Número final de la tarjeta bancaria',
  cancelWithdraw: 'Cancelar retiro',
  withdrawalDetails: 'Detalles del retiro',
  transferVoucher: 'Comprobante de transferencia',
  cancelWithdrawConfirm: 'Confirmación de cancelación de retiro',
  delPackageHint:
    'Después de confirmar la cancelación del retiro, el monto de retiro correspondiente se devolverá a tu saldo de comisión',
  withdrawTip:
    'Del día 1 (UTC+8) al 10 (UTC+8) de cada mes son días de retiro, y puedes elegir retirar del día 1 al 10',
  hasLogOff: 'Cancelado'
};
